<template>
  <loading
    :active.sync="loading"
    :can-cancel="false"
    :is-full-page="true"
    data-test="loading-overlay"
  >
    <bounce-loader
      :color="$theme.colors.orange"
      :size="120"
    />
  </loading>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import { BounceLoader } from '@saeris/vue-spinners';

  export default {
    components: {
      Loading,
      BounceLoader,
    },
    data: () => ({
      loading: false,
    }),
    methods: {
      start() {
        this.loading = true;
        return this;
      },
      finish() {
        this.loading = false;
        return this;
      },
      fail() {
        this.loading = false;
        return this;
      },
    },
  };
</script>

<style>
  .vld-overlay.is-full-page {
    z-index: 2001;
  }
</style>
